import {nl2sp} from './util.js';

export default {
    '/': {
        title: 'דף הבית',
        shortDesc: '',
        longDesc: nl2sp``,
    },
    '/tarot': {
        title: 'קריאה בקלפי הטארוט',
        shortDesc: '',
        longDesc: nl2sp``,
    },
    '/terms': {
        title: 'תנאי שימוש',
    },
    '/privacy-policy': {
        title: 'מדיניות פרטיות',
    },
    '/accessibility': {
        title: 'הצהרת נגישות',
    },
    '/counseling': {
        title: 'ייעוץ וליווי עסקי',
    },
    '/events': {
        title: 'מפגשים חווייתיים',
    },
    '/services': {
        title: 'השירותים שלי',
    },
    '/student_area': {
        title: 'אזור תלמידים',
    },
    '/tarotmail': {
        title: 'אפליקציית המסרים',
    },
    '/tarotmail/student': {
        title: 'אפליקציית המסרים',
    },
};
